import { get, post, put } from 'helpers/api';

const listingTypesByDealType = {
  lease: ['LeaseSpaceListing'],
  sale: ['SaleListing', 'LotListing', 'CondoListing'],
};

export function searchProjects(deal, query, callback) {
  let listingTypes;
  if (deal) {
    listingTypes = listingTypesByDealType[deal.dealType];
  } else {
    listingTypes = null;
  }
  // TODO: Get path externally
  get('/backoffice/vouchers/search_projects', {
    params: {
      listingTypes,
      query
    }
  }).then(callback);
}

export async function associateListing(deal, listing, propertyId = null) {
  return put(deal.path, { listingId: listing.id, syncToPropertyId: propertyId });
}

export async function getMerge(properties) {
  return await get(`/research/properties/merge.json?property_ids=[${properties.map(p => p.id).join(',')}]`);
}

export async function postMerge(properties, mappings) {
  return await post(`/research/properties/merge.json`, {
    property_ids: properties.map(p => p.id),
    mappings
  });
}
